export default __webpack_public_path__ + "static/media/Logo_ASM_logo-1.121095a0.png";